<template>
	<div class="homeyuntudiv">
		<div class="yuntutitle">{{colname}}</div>
		<el-table
		      :data="resultDataList"
		      style="width: 100%"
					max-height="325">
		      <el-table-column v-for="(item,index) in resultHeadList"
						align="center"
		        :prop="item.prop"
		        :label="item.label">
		      </el-table-column>
		    </el-table>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				resultDataList: [],
				resultHeadList:[],
			}
		},
		props: [
			'colid',
			'colname',
		],
		components:{
			
		},
		watch:{

		},
		created:function(){
			
		},
		mounted:function(){
			this.searchfnc();
		},
		methods: {
			searchfnc: function() {
				if(this.colid){
					let _this = this;
					_this.loadingMask = true;
					_this.resultDataList=[];
					_this.resultHeadList=[];
					this.$http({
							method: 'get',
							url: 'szjjchart/selectchartunstructureBytagID',
							responseType: 'json',
							params: {
								tagID:this.colid
							},
						})
						.then(function(response) {
							_this.resultDataList = JSON.parse(response.data.data.data.information);
							_this.resultDataList=_this.resultDataList.splice(0,5);
							if(_this.resultDataList.length>0){
								var tempkeys=Object.keys(_this.resultDataList[0]);
								for(var i=0;i<tempkeys.length&&i<3;i++){
									_this.resultHeadList.push({
										prop:tempkeys[i],
										label:tempkeys[i],
									})
								}
							}
							_this.loadingMask = false;
						})
						.catch(function(error) {
							_this.loadingMask = false;
							console.log(error);
						});
				}
			},
		}
	}
</script>

<style>
</style>
